import moment from 'moment';
import { accountService } from '../_services/account.service';

export function isActiveReservation(reservation) {
    if (reservation.isEnded) {
        console.log("Reservation ended")
        return false;
    }
    if (!reservation.isRedeemed) {
        console.log("Reservation not redeemed");
        return false;
    }
    let reservationEnd = getReservationEndDateTime(reservation);
    let now = moment();
    let startDate = moment(reservation.startDate, 'YYYY-MM-DD');
    if (now.isBefore(startDate, 'day')) {
        console.log("Reservation not started yet");
        return false;
    }
    if (now.isAfter(reservationEnd)) {
        console.log("Reservation expired");
        return false;
    }
    return true;
}

export function getReservationEndDateTime(reservation) {
    let eobString = accountService.configValue['endOfBusinessDay'] || '23:59';
    let [eobHour, eobMinute] = eobString.split(':').map(Number);
    if (isNaN(eobHour) || isNaN(eobMinute)) {
        eobHour = 23;
        eobMinute = 59;
    }
    let endDate = moment(reservation.endDate, 'YYYY-MM-DD');
    let reservationEnd;
    if (eobHour < 12) {
        reservationEnd = endDate.set({ hour: eobHour, minute: eobMinute });
    } else {
        reservationEnd = endDate.add(-1, 'days').set({ hour: eobHour, minute: eobMinute });
    }
    return reservationEnd;
}